const VideoIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.0498 7.78999L7.9998 5.49999V14.5L11.0498 12.21L13.9998 9.99999L11.0498 7.78999ZM11.0498 7.78999L7.9998 5.49999V14.5L11.0498 12.21L13.9998 9.99999L11.0498 7.78999ZM11.0498 7.78999L7.9998 5.49999V14.5L11.0498 12.21L13.9998 9.99999L11.0498 7.78999ZM8.9998 2.06999V0.0499878C6.9898 0.249988 5.1598 1.04999 3.6798 2.25999L5.0998 3.68999C6.20981 2.82999 7.5398 2.24999 8.9998 2.06999ZM3.6898 5.09999L2.2598 3.67999C1.0498 5.15999 0.249805 6.98999 0.0498047 8.99999H2.0698C2.2498 7.53999 2.8298 6.20999 3.6898 5.09999ZM2.0698 11H0.0498047C0.249805 13.01 1.0498 14.84 2.2598 16.32L3.6898 14.89C2.8298 13.79 2.2498 12.46 2.0698 11ZM3.6798 17.74C5.1598 18.95 6.9998 19.75 8.9998 19.95V17.93C7.5398 17.75 6.20981 17.17 5.0998 16.31L3.6798 17.74ZM19.9998 9.99999C19.9998 15.16 16.0798 19.42 11.0498 19.95V17.93C14.9698 17.41 17.9998 14.05 17.9998 9.99999C17.9998 5.94999 14.9698 2.58999 11.0498 2.06999V0.0499878C16.0798 0.579988 19.9998 4.83999 19.9998 9.99999Z"
        fill="#EE5D50"
      />
    </svg>
  );
};

export default VideoIcon;
